import component from './e-dropdown.vue'

import './e-dropdown.scss'

export default component
